module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAABICAYAAACeNle5AAABCUlEQVRoge3aMQoCQQyF4dzAvdTeY23EKwg2goWVjYjHtBAbFX6bXVjBaiYxI7zi1fMxmUmamJkZsAB6YABWP84wnr2wEdMlQb7BOht12ZgpvTVyO1OW1gDiIwIJJJBA2RFIIIEEyo5AEaB1S6AL8ATOrYA2wBV4RaFKSraNRJU+6jBUzS8LQdV+e3eURx9yRXk1RjeUZ6d2QXmPjmpUxCyrQkUN1znq0AJoB9yAB7DPBs0xx+ySVWG8QdUYT5ALxgvkhvEAuWJqQe6YGlAIphQUhikBbSMxJaATcI/ClJYsNAIJJJBA2RFIIIEEyo5AfwlqbqGpuZWvtpbiZpt6PbDMKNN4dmdm9gaNW1sp1ibVTwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/rightArrow.png
// module id = 3XUY
// module chunks = 0